import { compareAsStrings } from "../string";

export const orderStringArray = (array: string[]) =>
  [...array].sort((item1, item2) => compareAsStrings(item1, item2));
